import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
} from "@mui/material";
import axios from "../../../../Uri";
import { buildingSummary } from "redux/actions/RatActions";
import { useDispatch,useSelector } from "react-redux";
function SummaryTable(props) {
  const apidata = useSelector((state)=>state.buildings.buildingSummary)
  var totalbed = null;
  var occupiedBed = null;
  var availBed = null;
  var guestInNotices = null;
  var guestOndue = null;
  var totaldue = null;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(buildingSummary(props.buildingId));
  },[props.buildingId]);
  function createData(name, calories) {
    return { name, calories };
  }
  console.log(apidata);
  apidata.map((m) => {
    totalbed = m.totalBeds;
    occupiedBed = m.occupiedBeds;
    availBed = m.availableBeds;
    guestInNotices = m.guestsInNotice;
    guestOndue = m.guestsOnDue;
    totaldue = m.totalDueAmount;
    console.log(m.totalBeds);
  });
  const rows = [
    createData(<h4>Total Beds</h4>, totalbed),
    createData(<h4>Occupied Beds</h4>, occupiedBed),
    createData(<h4>Available Beds</h4>, availBed),
    createData(<h4>Guests in Notice</h4>, guestInNotices),
    createData(<h4>Guests on Due</h4>, guestOndue),
    createData(<h4>Total Due Amount</h4>, totaldue),
  ];
  return (
    <Grid container spacing={2} columns={16}>
      <Grid item xs={8}>
        <Table
          sx={{
            minWidth: 250,
            "@media screen and (min-width: 40em)": {
              minWidth: 500,
            },
          }}
          aria-label="a dense table"
        >
          <TableHead>
            <TableRow></TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell align="right">{row.calories}</TableCell>
                <TableCell align="right">{row.fat}</TableCell>
                {/* <TableCell align="right">{row.carbs}</TableCell> */}
                <TableCell align="right">{row.protein}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  );
}
export default SummaryTable;
